import { render, staticRenderFns } from "./ButtonView.vue?vue&type=template&id=f5f02d72&"
import script from "./ButtonView.vue?vue&type=script&lang=js&"
export * from "./ButtonView.vue?vue&type=script&lang=js&"
import style0 from "./ButtonView.vue?vue&type=style&index=0&id=f5f02d72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports